
'use strict';

import React from 'react';
import {useMemo} from 'react';

import {Form} from "@quillforms/renderer-core";
import {registerCoreBlocks} from "@quillforms/react-renderer-utils";
import "@quillforms/renderer-core/build-style/style.css";

registerCoreBlocks();

import {createHomeworkRecord} from '../frontend/ajax.js';
import {css} from 'emotion';
import {formDefinitionFillIds} from '../helpers/formDefinitionFillIds.js';
import {formDefinitionToQuillFormDefinition} from '../helpers/formDefinitionToQuillFormDefinition.js';
import {formFill} from '../frontend/ajax.js';
import {formLoad} from '../frontend/ajax.js';
import {getHomeworkRecord} from '../frontend/ajax.js';
import {registerBlockTypeHTML} from '../frontend/helpers/quillforms/registerBlockTypeHTML.jsx';
import {registerBlockTypeOpinionScale} from '../frontend/helpers/quillforms/registerBlockTypeOpinionScale.jsx';
import {useFirstRender} from '../utilities/React.js';
import {useStateAtom} from '../utilities/React/UseStateAtom.js';
import {yamlParse} from '../utilities/yaml/yamlParse.js';

registerBlockTypeHTML();
registerBlockTypeOpinionScale();

export default function (props) {

  const definitionAST = useStateAtom(null);
  const homeworkRecordInfo = useStateAtom(null);

  const blocks = useMemo(
    () => {
      const map = {};
      for (const page of definitionAST()?.pages ?? [])
        for (const block of page.blocks) {
          map[block.id] = block;
          if (block.component == 'Group')
            for (const subBlock of block.blocks)
              map[subBlock.id] = subBlock;
        }
      return map;
    },
    [
      definitionAST(),
    ],
  );

  useFirstRender(async () => {
    definitionAST(formDefinitionFillIds(JSON.parse(props.block.html).definitionAST));
    homeworkRecordInfo(await getHomeworkRecord(props.lesson.id));
  });

  return (<>

    <div
      id={props.id}
      className={'pi3courseForm ' + css`
        border: 1px solid #edeff6;
        position: relative;
        width: 100%;
        height: 640px;
      `}
    >
      {(() => {

        if (!homeworkRecordInfo())
          return (<>
            <div>
              {/* @todo Display loading? */}
            </div>
          </>);

        if (homeworkRecordInfo().homeworkRecord)
          return (<>
            <div
              className={css`
                position: relative;
                width: 100%;
                height: 100%;
                display: flex;
                place-content: center;
                place-items: center;
                font-size: 26px;
                line-height: 1.5em;
                text-align: center;
              `}
            >
              <div>
                <p>
                  &nbsp;
                </p>
                <p>
                  &nbsp;
                </p>
                <p>
                  <strong>Homework already submitted!</strong>
                </p>
                <p>
                  &nbsp;
                </p>
                <p>
                  &nbsp;
                </p>
                <p>
                  &nbsp;
                </p>
              </div>
            </div>
          </>);

        return (<>
          {definitionAST() && (<>
            <Form
              formId="1"
              formObj={{
                theme: {
                  buttonsBgColor: '#9a1638',
                },
                messages: {
                  'label.submitBtn': 'Submit Homework',
                  'block.defaultThankYouScreen.label': `
                    <p>
                      &nbsp;
                    </p>
                    <p>
                      &nbsp;
                    </p>
                    <p>
                      <strong>Homework submitted!</strong>
                    </p>
                    <p>
                      &nbsp;
                    </p>
                    <p>
                      &nbsp;
                    </p>
                    <p>
                      &nbsp;
                    </p>
                  `,
                },
                settings: {
                  showQuestionsNumbers: false,
                  showLettersOnAnswers: false,
                },
                customCSS: `
                  /**
                   * The following z-index tweaks are required to fix Quill forms
                   * having a footed that is displayed over the dropdown options
                   * making the dropdown options unselectable.
                   */
                  .renderer-core-fields-wrapper {
                    z-index: 10000;
                  }
                  .renderer-core-block-stack-layout {
                    z-index: 10001;
                  }
                `,
                ...formDefinitionToQuillFormDefinition(definitionAST()),
              }}
              onSubmit={async (data, options) => {
                await createHomeworkRecord(
                  props.lesson.id,
                  {
                    answers: Object.entries(data.answers).map(([k, v]) => ({
                      id: k,
                      value: v.value,
                      component: blocks[k]?.component ?? '',
                      props: blocks[k]?.props ?? {},
                      metadata: blocks[k]?.metadata ?? {},
                      quillFormsData: v,
                    })),
                    testMode: (new URLSearchParams(window.location.search)).get('test-mode') == 'true',
                  },
                  {},
                );
                await new Promise(r => setTimeout(r, 500));
                options.setIsSubmitting(false);
                options.completeForm();
              }}
            />
          </>)}
        </>);

      })()}
    </div>

  </>);

};
